/** Inclusive lower bound for the rolling 7-day window ending at the current moment. */
function getLast7DaysCutoff() {
  return new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
}

export function isVerifiedAction(action) {
  if (action == null) return false;
  return action.verified === 1 || action.verified === true || action.verified === '1';
}

/**
 * Verified actions whose `created_at` falls within the last 7 days (rolling window from now).
 * Uses the same `userActions` list the app already scopes to the current user.
 */
export function filterVerifiedActionsLast7Days(actions) {
  const cutoff = getLast7DaysCutoff();
  return (actions || []).filter((a) => {
    if (!isVerifiedAction(a)) return false;
    const t = new Date(a.created_at);
    return !Number.isNaN(t.getTime()) && t >= cutoff;
  });
}

export function tierFromVerifiedCount(n) {
  if (n >= 5) return 'gold';
  if (n >= 3) return 'silver';
  if (n >= 1) return 'bronze';
  return null;
}

export const TIER_RANK = { bronze: 1, silver: 2, gold: 3 };

export function tierAtLeast(currentTier, requiredTier) {
  if (!currentTier || !requiredTier) return false;
  return TIER_RANK[currentTier] >= TIER_RANK[requiredTier];
}

export function formatTierLabel(tier) {
  if (!tier) return 'No tier';
  return tier.charAt(0).toUpperCase() + tier.slice(1);
}

/** Tier from verified actions in the rolling last 7 days (Bronze 1+, Silver 3+, Gold 5+). */
export function getWeeklyTierStats(actions) {
  const verified = filterVerifiedActionsLast7Days(actions);
  const verifiedCountLast7Days = verified.length;
  const tier = tierFromVerifiedCount(verifiedCountLast7Days);
  return {
    verifiedCountLast7Days,
    tier,
    tierLabel: formatTierLabel(tier),
  };
}
